import Swiper, { Pagination } from 'swiper'

import './cases.scss'

const initCasesSwiper = () => {
  new Swiper('.cases__swiper.swiper', {
    modules: [Pagination],
    slidesPerView: 'auto',
    spaceBetween: 16,

    pagination: {
      type: 'bullets',
      dynamicBullets: true,
      el: '.cases__swiper-pagination.swiper-pagination',
    },

    breakpoints: {
      768: {
        enabled: false,
        spaceBetween: 0,
      },
    },
  })
}

document.addEventListener('DOMContentLoaded', async function () {
  initCasesSwiper()
})
